/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type GeneratedAssignmentStatus = 'IN_PROGRESS' | 'CANCELED' | 'COMPLETED';

export const GeneratedAssignmentStatus = {
  InProgress: 'IN_PROGRESS' as GeneratedAssignmentStatus,

  Canceled: 'CANCELED' as GeneratedAssignmentStatus,

  Completed: 'COMPLETED' as GeneratedAssignmentStatus,
};
